<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" rx="3" fill="#7C5CFC" />
    <path d="M4.5 5.5h7" stroke="white" stroke-width="1.25" stroke-linecap="round" />
    <path d="M8 5.5v6" stroke="white" stroke-width="1.25" stroke-linecap="round" />
    <path d="M5.5 13h5" stroke="url(#traciora-trace)" stroke-width="0.5" stroke-linecap="round" />
    <defs>
      <linearGradient id="traciora-trace" x1="5.5" y1="13" x2="10.5" y2="13" gradientUnits="userSpaceOnUse">
        <stop stop-color="#4A2FB8" />
        <stop offset="0.5" stop-color="#B4A0FF" />
        <stop offset="1" stop-color="#FAFAFA" />
      </linearGradient>
    </defs>
  </svg>
</template>
